import { render, staticRenderFns } from "./OrderGroupItem.vue?vue&type=template&id=f4af4ff8"
import script from "./OrderGroupItem.vue?vue&type=script&lang=js"
export * from "./OrderGroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports